import React, { Component } from 'react';
import { SkeletonPlaceholder } from 'carbon-components-react';
import { api } from '../../../helpers/api/api';
/**
 * recupera e visualizza in un tag img la firma caricata su azure
 * fileIdentifier: string (signatureAttachment)
 */
export default class AuditImgSignature extends Component {

    constructor(props) {
        super(props);
        this.state = {
            src: null,
            isLoading: true,
        }
    }

    componentDidMount() {        
        api.getWithParam(`audit/${this.props.auditNotification.id}/signature`,{ params: { signatureAttachment: this.props.auditNotification.signatureAttachment }})
            .then(response => {
                let data = response.data;
                this.setState({
                    src: data,
                });
            }).catch(error => {
                console.error(error);
            }).finally(() => {
                this.setState({
                    isLoading: false,
                });
            });
    }

    render() {
        return (
            this.state.isLoading ?
                <SkeletonPlaceholder className="dual-list-placeholder max-width" /> :
                <img alt="signature" src={this.state.src} />
        );
    }
}
